import EditComponent from './ExitMethodEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponents = (props: any) => {

    /** api服务id */
    const apiId = 'exitMethod';

    //表头
    const columnsHead = [
        {
            title: '退出方式',
            dataIndex: 'exitMethodName'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '退出方式',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponents;
